import { deletedata } from '@/util/global';
import React from 'react';

const MessageTable = ({ messagedata}) => {
  const rows = [];

  for (let i = 0; i < messagedata.length; i++) {
    const a = messagedata[i];
    rows.push(
      <tr key={a._id || i}>
        <td>{a.updatetimestamp}</td>
        <td>{a.senderphonenumber}</td>
        <td>{JSON.stringify(a.receiverphonenumber)}</td>
        <td>{a.message}</td>
        <td>{a.status}</td>
      </tr>
    );
  }

  return (
    <table className="grid" >
      <thead>
        <tr><th>timestamp</th><th>sender</th><th>receiver</th><th>messages</th><th>status</th></tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
};

export default MessageTable;